export type Visibility = "public" | "private" | "unlisted";
export type VisibilityNumber = 0 | 1 | 2;

export function visibilityToNumber(visibility: Visibility) {
  switch (visibility) {
    case "public":
      return 0;
    case "unlisted":
      return 1;
    case "private":
      return 2;
  }
}

export function numberToVisibility(visibility: VisibilityNumber) {
  switch (visibility) {
    case 0:
      return "public";
    case 1:
      return "unlisted";
    case 2:
      return "private";
  }
}
